import {useDispatch, useSelector} from 'react-redux';
import {messageClosed, selectAllMessages} from './messagesSlice';
import Alert from '../../components/ui/Alert';
import React from 'react';

const Messages = () => {
  const dispatch = useDispatch()
  const messages = useSelector(selectAllMessages)

  return (
    <>
      { messages.map((item, index) => {
            return (
              <>
                {
                  item.open &&
                  <Alert key={index} onClose={() => dispatch(messageClosed(item.id))}>
                    {item.text}
                  </Alert>
                }
              </>
            )
          }
        )
      }
    </>
  )
}

export default Messages